import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../../../variants";
import Biographie from "./data";
import BioPic from "../../assets/about/about.jpg";
import "./index.css";

const About = () => {
  // Fonction pour empêcher les actions de copier, coller et glisser-déposer
  const preventDefaultActions = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div className="about" style={{ overflowX: "hidden" }}>
        <h2 className="title">VINCENT FERNANDEL</h2>
        <div className="biographie-border"></div>
        <div className="biographie">
          {Biographie.map((item, index) => (
            <div className="biographie-list">
              <p>{item.para}</p>
              <p style={{ marginTop: "20px" }}>{item.para2}</p>
              <p style={{ paddingTop: "1rem" }}>{item.para3} </p>
              <p style={{ paddingTop: "1rem" }}>{item.para4} </p>
              <p style={{ paddingTop: "1rem" }}>
                {item.para5}{" "}
                <a
                  style={{ color: "black", fontWeight: "bold" }}
                  href="https://www.vincent-fernandel.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.vincent-fernandel.com
                </a>
              </p>
            </div>
          ))}
          <motion.div
            variants={fadeIn("left", 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.1 }}
            
            className="biographie-right"
          >
            <img
              className="biographie-pic"
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={BioPic}
              alt=""
            />
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default About;
